import SectionCRatingBox from "../utils/SectionCRatingBox";
import RequirementSection from "../components/RequirementSection";

const renderHeader = (requirements) => <SectionCRatingBox requirements={requirements} />;

const SectionC = () => <RequirementSection section="C" renderHeader={renderHeader} />;

export default SectionC;